import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import MobileStepper from '@mui/material/MobileStepper';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

const PagesStepper = function DotsMobileStepper({
  currentStep,
  handleChangeStep, //function that accepts + or - number of steps
  max, //number of steps
  variant = 'dots',
  position = 'bottom',
  direction = 'ltr',
  nextText = null,
  backText = null,
  nextStyle = null,
  backStyle = null,
  submitStep = false,
}) {
  const intl = useIntl();

  const nextDefaultIcon = useMemo(
    () =>
      direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />,
    [direction]
  );
  const backDefaultIcon = useMemo(
    () =>
      direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />,
    [direction]
  );

  return (
    <MobileStepper
      variant={variant}
      steps={max}
      position={position}
      activeStep={currentStep}
      sx={{ position: 'sticky', width: '100%', backgroundColor: 'transparent' }}
      nextButton={
        <Button
          type={submitStep ? 'submit' : 'button'}
          variant={submitStep ? 'contained' : 'text'}
          onClick={(e) => {
            if (!submitStep) {
              e.preventDefault();
              handleChangeStep(+1);
            }
          }}
          disabled={!submitStep && currentStep === max - 1}
          sx={nextStyle}
        >
          {nextText || intl.messages.NEXT}
          {nextText ? null : nextDefaultIcon}
        </Button>
      }
      backButton={
        <Button
          onClick={() => handleChangeStep(-1)}
          disabled={currentStep === 0}
          sx={backStyle}
          variant="text"
        >
          {backText ? null : backDefaultIcon}
          {backText || intl.messages.BACK}
        </Button>
      }
    />
  );
};
PagesStepper.propTypes = {
  variant: PropTypes.string,
  currentStep: PropTypes.number.isRequired,
  handleChangeStep: PropTypes.func.isRequired,
  max: PropTypes.number.isRequired,
  position: PropTypes.string,
  direction: PropTypes.string,
  nextText: PropTypes.string,
  backText: PropTypes.string,
  nextStyle: PropTypes.object,
  backStyle: PropTypes.object,
  submitStep: PropTypes.bool,
};

export default PagesStepper;
